//@ts-nocheck

const loadWorks = () => {
	const worksContainer = document.querySelector(".js-works-container");
	const loadWorksBtnContainer = document.querySelector(".js-load-works-btn-container");
	const loadMoreBtn = document.querySelector(".js-load-works-btn");

	if (!worksContainer || !loadMoreBtn || !loadWorksBtnContainer) return;

	let timesLoaded = 1;
	const maxLoads = worksContainer.dataset.maxLoads;
	const perLoad = worksContainer.dataset.perLoad;

	loadMoreBtn.addEventListener("click", async function () {
		try {
			timesLoaded++;

			let formData = new FormData();
			formData.append("action", "fa_load_works");
			formData.append("times_loaded", timesLoaded);
			formData.append("per_load", perLoad);

			worksContainer.classList.add("loading");

			const response = await fetch(ajaxurl, {
				method: "POST",
				body: formData,
			});

			const res = await response.json();
			worksContainer.innerHTML = res.data;

			worksContainer.classList.remove("loading");

			if (timesLoaded >= maxLoads) {
				loadWorksBtnContainer.remove();
			}
		} catch (e) {
			timesLoaded--;
			console.log("An error occured");
			worksContainer.classList.remove("loading");
		}
	});
};

export default loadWorks;
